import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Auth from "../views/Auth.vue";
import AppShell from "../views/AppShell.vue";
import Login from "../views/Login.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import ResetPassword from "../views/ResetPassword.vue";
import SignUp from "../views/SignUp.vue";
import DomainsList from "../views/DomainsList.vue";
import Dashboard from "../views/Dashboard.vue";
import DomainDetail from "../views/DomainDetail.vue";
import NotificationGroupsList from "../views/NotificationGroupsList.vue";
import NotificationsSetup from "../views/NotificationsSetup.vue";
import AccountView from "@/views/AccountView.vue";
import { AuthError } from "@/enums/AuthError";
import AccountSecurity from "@/views/AccountSecurity.vue";
import AccountGeneral from "@/views/AccountGeneral.vue";
import AccountSubscription from "@/views/AccountSubscription.vue";
import VerifyEmail from "@/views/VerifyEmail.vue";
import Inbox from "@/views/Inbox.vue";
import NotFound from "@/views/NotFound.vue";

const UsersListForAdmin = () =>
	import(/* webpackChunkName: "group-admin" */ "@/views/UsersListForAdmin.vue");
const UserDetailForAdmin = () =>
	import(/* webpackChunkName: "group-admin" */ "@/views/UserDetailForAdmin.vue");

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
	{
		path: "/auth",
		name: "auth",
		component: Auth,
		children: [
			{
				path: "login",
				name: "login",
				component: Login,
			},
			{
				path: "signup",
				name: "signup",
				component: SignUp,
			},
			{
				path: "forgot-password",
				name: "forgot-password",
				component: ForgotPassword,
			},
			{
				path: "reset-password",
				name: "reset-password",
				component: ResetPassword,
			},
			{
				path: "verify-email",
				name: "verify-email",
				component: VerifyEmail,
			},
		],
	},
	{
		path: "/",
		name: "App Shell",
		component: AppShell,
		beforeEnter: (to, from, next) => {
			if (localStorage.getItem("access_token")) {
				next();
			} else {
				next("/auth/login?error=" + AuthError.UNAUTHENTICATED + "&redirectTo=" + to.path);
			}
		},
		children: [
			{
				path: "account",
				component: AccountView,
				children: [
					{
						path: "general",
						component: AccountGeneral,
					},
					{
						path: "subscription",
						component: AccountSubscription,
					},
					{
						path: "security",
						component: AccountSecurity,
					},
				],
			},
			{
				path: "domains",
				component: DomainsList,
			},
			{
				path: "domains/:id",
				name: "domain-details",
				component: DomainDetail,
			},
			{
				path: "notifications",
				name: "notifications",
				component: NotificationGroupsList,
			},
			{
				path: "notifications/setup",
				name: "notifications-setup",
				component: NotificationsSetup,
			},
			{
				path: "notifications/:id",
				name: "notification-group",
				component: NotificationsSetup,
			},
			{
				path: "dashboard",
				component: Dashboard,
			},
			{
				path: "admin/users",
				component: UsersListForAdmin,
			},
			{
				path: "admin/users/:id",
				component: UserDetailForAdmin,
			},
			{
				path: "inbox",
				component: Inbox,
			},
		],
	},
	{
		path: "*",
		component: NotFound,
	},
];

const router = new VueRouter({
	mode: "history",
	base: process.env.BASE_URL,
	routes,
});

export default router;
